import { config } from "config";

export const generateURL = (url?: string): string => {
  if (!url) return "";
  return config.ASSET_URL + url;
};
